import { useSelector } from 'react-redux';
import { getRole } from 'features/Auth/auth';
import { Roles } from './roles';

const useRole = () => {
  const role = useSelector(getRole);

  const showAdmin = role === Roles.Admin;
  const showCompany = role === Roles.Company || role === Roles.Company_alias;
  const showSupervisor = role === Roles.Supervisor;
  const showCommon = role === Roles.Common;

  return {
    showAdmin,
    showCommon,
    showCompany,
    showSupervisor
  };
};

export { useRole };
